export default __webpack_public_path__ + "static/media/loader.8b38f464.svg";